import Swiper from 'swiper';
import { breakpoints, measurements } from '../conf';

export const options = {
  slidesPerView: 'auto',
  spaceBetween: measurements.gutterWidth,
  slidesOffsetBefore: measurements.pageMarginXs,
  slidesOffsetAfter: measurements.pageMarginXs,
  navigation: {
    nextEl: '[data-card-swiper-next]',
    prevEl: '[data-card-swiper-prev]',
  },
  scrollbar: {
    el: '[data-card-swiper-scrollbar]',
    hide: false,
  },
  breakpoints: {
    [breakpoints.md]: {
      slidesPerView: 2,
      spaceBetween: measurements.gutterWidth,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
    [breakpoints.lg]: {
      slidesPerView: 3,
      spaceBetween: measurements.gutterWidth,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
  },
};

export default () => {
  const els = document.querySelectorAll('[data-card-swiper]');

  if (els.length) {
    els.forEach((el) => {
      const parentEl = el.parentElement;
      const attrOptions = el.dataset.cardSwiper ? JSON.parse(el.dataset.cardSwiper) : {};

      options.navigation.nextEl = parentEl.querySelectorAll('[data-card-swiper-next]');
      options.navigation.prevEl = parentEl.querySelectorAll('[data-card-swiper-prev]');
      options.scrollbar.el = parentEl.querySelector('[data-card-swiper-scrollbar]');

      if (parentEl.classList.contains('card-swiper--v-center-nav')) {
        const repositionNav = () => {
          const slideImg = parentEl.querySelector('.card-swiper__slide img');

          if (slideImg) {
            const imgHeight = slideImg.clientHeight;
            const swiperArrows = parentEl.querySelectorAll('.swiper-arrow-prev, .swiper-arrow-next');

            swiperArrows.forEach((arrowEl) => {
              arrowEl.style.top = (imgHeight > 0) ? `${imgHeight / 2}px` : null;
            });
          }
        };

        options.on = {
          update: () => { setTimeout(repositionNav, 10); },
          resize: repositionNav,
        };
      }

      const swiper = new Swiper(el, { ...options, ...attrOptions });

      return swiper;
    });
  }
};
